var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartBarClaimsYearOverYear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "60px",
    viewBox: "0 0 138 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E9266EBC-02EB-4E7D-B261-7B5B82AAAF31") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage---Edit-Metrics---Alternate",
    transform: "translate(-323.000000, -337.000000)",
    fill: "#337DC7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-119",
    transform: "translate(223.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-73",
    transform: "translate(61.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-bar-claims-year-over-year",
    transform: "translate(39.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    x: 0,
    y: 33,
    width: 15,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    x: 18,
    y: 33,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    x: 36,
    y: 33,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    x: 52,
    y: 33,
    width: 14,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.3,
    x: 69,
    y: 33,
    width: 15,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 87,
    y: 26,
    width: 15,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 105,
    y: 17,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 123,
    y: 0,
    width: 15,
    height: 32
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarClaimsYearOverYear);
export default __webpack_public_path__ + "static/media/chart-bar-claims-year-over-year.a302ad98d4eab33f9e17f029faec7a93.svg";
export { ForwardRef as ReactComponent };